__turbopack_context__.v({
  "alert": "positionSection-module-scss-module__8pao4G__alert",
  "checkboxLabel": "positionSection-module-scss-module__8pao4G__checkboxLabel",
  "positions": "positionSection-module-scss-module__8pao4G__positions",
  "signIn": "positionSection-module-scss-module__8pao4G__signIn",
  "wrapper": "positionSection-module-scss-module__8pao4G__wrapper",
});
